// src/templateManager/components/tabs/ContextFieldsTab.jsx
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import {
  Stack,
  Alert
} from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import ContextFieldsEditor from '../../ContextFieldsEditor';

/**
 * ContextFieldsTab - Flexible context field configuration
 * Allows creating custom categories and fields
 */
function ContextFieldsTab() {
  const { control } = useFormContext();

  return (
    <Stack gap="lg">
      {/* Info */}
      <Alert icon={<IconInfoCircle size={16} />} color="blue">
        Define the context forms shown to users at the start of an assessment. Each category becomes a separate form section with its own fields.
      </Alert>

      {/* Context Fields Editor */}
      <Controller
        name="taxonomy.contextFields"
        control={control}
        render={({ field }) => (
          <ContextFieldsEditor
            value={field.value || {}}
            onChange={field.onChange}
          />
        )}
      />
    </Stack>
  );
}

export default ContextFieldsTab;
